//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data(){
      return {
        radio:'',
        find:'',
        patientid: this.$store.state.userInfo.id,
        addressTitle:[],
        orederId: this.$route.query.orederId||'',
        selectType:this.$route.query.selectType||'',
        fromType: this.$route.query.fromType||'',//
        type: this.$route.query.type||'',
        orderId:this.$route.query.orderId||'',
        paidTypes:this.$route.query.paidTypes||'',
        befrom:this.$route.query.befrom||'',
      }
    },
    methods:{
      getcodes(items,type){
        if(type==1){
//          console.log(items);
          this.$store.state.inquirypeople=items;
          if(this.$store.state.AllOfValue.ImDoctorInfo){
            this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId=items.id;
            this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientName=items.name;
          };

          this.$router.push({path: '/buyServiceDetails'});
        }else if(
          type==2
        ){
          this.$store.state.inquirypeople=items;
          this.$router.push({path: '/myOrderDetailsYF',query:{id:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
        }else if(
          type==3
        ){
          this.$store.state.inquirypeople=items;
          this.$router.push({path: '/myCaseList',query:{pd:1}});

        }
//        else if(type==undefined||type==''||type==null){
//          this.$router.push({path: '/inquiryPeopleAdd',query:{id:items,orederId: this.orederId,selectType:this.selectType}});
// }
        },
      addAddress(){
        if(this.addressTitle.length<=0){
          this.$router.push({path: '/inquiryPeopleAdd',query: {patientid: this.patientid,selectType:this.selectType,orderId:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
        }else{
          this.$router.push({path: '/inquiryPeopleDaa',query: {patientid: this.patientid,selectType:this.selectType,orderId:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
        }
      },
      getMyAddress(){
        let params = {
          parameters: this.patientid
        };
        let _this=this;
        this.$doRequest("/api/inquiryPeople/getPatientInquiryPatient", params, res=>{
          _this.addressTitle=res.parameters;
        })
      },
      editClick(item){
        this.$router.push({path: '/inquiryPeopleAdd',query:{id:item,orederId: this.orederId,selectType:this.selectType,orderId:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
      },
      delClick(item){
//        console.log(item);

        let _this=this;
        if(item.relationCode=='br'){
          _this.$toastMsg('本人关系不允许删除');
          return
        }
        this.$doRequest("/api/inquiryPeople/updateInquiryPeople", {id:item.id,state:'2',relationId:item.relationId}).then(res => {
          if(res.result == 0){
            _this.$toastMsg('删除成功');
            _this.getMyAddress();
          }
        })
      },
      queryDoctor(){
        this.pagination = 1;
        this.patientid=this.find;
        this.getMyAddress();
      },
      goback(){
        this.$router.push({path: '/myManage'});
      }

    },
    created(){
      document.title = '就诊人管理';
      if(this.$store.state.userInfo.telephone==''||this.$store.state.userInfo.telephone==null||!this.$store.state.userInfo.telephone){
        this.$router.push({path: '/boundPhone',query:{form:'inquiryPeople'}})};
        this.orederId = this.$route.query.id;
    },
    mounted(){
      this.getMyAddress();
    }
  }



// WEBPACK FOOTER //
// ./src/views/inquiryPeople/index.vue